import React from 'react'
import { Box, Typography, Tooltip } from '@the-platform-group/component-library'
import { Grid } from '@the-platform-group/component-library/Layout'
import { formatDate } from '@the-platform-group/formatters/dateFormat'

/**
 * Email Grader Component that displays the details of the email like grade, smtp valid, and last validation check
 * @param {Object} email - The email object
 * @returns {React.Component} - The EmailGrader component
 */
const EmailGrader = ({ email }) => {
  const emailGrade = email?.grade

  return (
    <Tooltip
      title={
        <Grid container>
          <Grid item xs={12}>
            <Typography variant="body2">Grade: {emailGrade}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body2">SMTP Valid: {email?.smtpValid ? 'Yes' : 'No'}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body2">
              Last Validation Check: {formatDate(email?.lastValidationCheck)}
            </Typography>
          </Grid>
        </Grid>
      }
    >
      <Box
        sx={{
          bgcolor: emailGrade === 'A' ? 'primary.main' : 'warning.main',
          width: 18,
          height: 18,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'primary.brighter',
          borderRadius: 1,
          fontSize: 10,
        }}
      >
        <Typography variant="body2">{emailGrade}</Typography>
      </Box>
    </Tooltip>
  )
}

export default EmailGrader
